import { Button, Form, Modal, message } from "antd";
import { useState } from "react";
import DataTable from "../../../../../components/Tables/DataTable";
import FormModal from "./FormModal";
import dayjs from "dayjs";
import {
  useAddCountryMutation,
  useDeleteCountryMutation,
  useEditCountryMutation,
  useGetCountriesQuery,
} from "../../../../../redux/Service/countriesApi";

function Countries() {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isEditing, setIsEditing] = useState<boolean>(false);

  const {
    data: countriesData,
    isLoading: isCountriesLoading,
    isError: isCountriesError,
  } = useGetCountriesQuery(undefined);

  const countries = countriesData?.ResponseObject ?? [];

  const [deleteCountry, { isLoading: isDeleting }] = useDeleteCountryMutation();
  const [addCountry, { isLoading: isAdding }] = useAddCountryMutation();
  const [updateCountry, { isLoading: isUpdating }] = useEditCountryMutation();

  const handleDeletClick = (record: any) => {
    Modal.confirm({
      title: "تأكيد الحذف",
      content: `هل أنت متأكد أنك تريد حذف البلد "${record.CountryID}"؟`,
      okText: "حذف",
      okType: "danger",
      cancelText: "إلغاء",
      onOk: async () => {
        try {
          const response = await deleteCountry(record.CountryID).unwrap();
          if (response?.ResponseObject === true) {
            message.success("تم حذف البلد بنجاح");
          } else {
            message.error("حدث خطأ أثناء الحذف");
          }
        } catch (error) {
          message.error("فشل الاتصال بالخادم");
        }
      },
    });
  };

  const columns: any = [
    {
      title: "كود البلد",
      dataIndex: "CountryID",
      key: "CountryID",
    },
    {
      title: "اسم البلد",
      dataIndex: "CountryName",
      key: "CountryName",
    },
  ];

  const handleOk = async (values: any) => {
    // Construct the body with the required CountryID and CountryName fields
    const body = {
      ...values,
    };
    console.log("body", body);

    try {
      let response;
      if (isEditing) {
        response = await updateCountry(body).unwrap();
      } else {
        response = await addCountry(body).unwrap();
      }
      if (response?.ResponseObject === true) {
        message.success(
          isEditing ? "تم تعديل البلد بنجاح" : "تمت إضافة البلد بنجاح"
        );
        setIsModalOpen(false);
        resetModal();
      } else {
        message.error("حدث خطأ أثناء العملية");
      }
    } catch (error) {
      message.error("فشل الاتصال بالخادم");
    }
  };

  function resetModal() {
    form.resetFields();
    setIsEditing(false);
  }

  const handleCancel = () => {
    setIsModalOpen(false);
    resetModal();
  };

  const handleEditClick = (record: any) => {
    setIsEditing(true);
    setIsModalOpen(true);

    const recordData = { ...record };
    if (recordData.DocDate) {
      recordData.DocDate = dayjs(recordData.DocDate);
    }
    setTimeout(() => {
      form.setFieldsValue(recordData);
    }, 0);
  };

  return (
    <>
      <div className="flex flex-wrap gap-4 relative">
        <div className="grid justify-start my-2">
          <Button
            type="primary"
            style={{ width: "10rem" }}
            onClick={() => setIsModalOpen(true)}
          >
            إضافه
          </Button>
        </div>

        <FormModal
          form={form}
          isEditing={isEditing}
          isModalOpen={isModalOpen}
          handleOk={handleOk}
          handleCancel={handleCancel}
          loading={isUpdating || isAdding}
        />

        <DataTable
          columns={columns}
          data={countries}
          handleEditClick={handleEditClick}
          handleDeletClick={handleDeletClick}
          isLoading={isCountriesLoading || isDeleting}
        />
      </div>
    </>
  );
}

export default Countries;
